import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useState } from "react";
import {
  createWorkedExample as createWorkedExampleService,
  updateWorkedExample as updateWorkedExampleService,
  deleteWorkedExample as deleteWorkedExampleService,
} from "../../services/developmental-rubrics/worked-example.service .js";

import {
  updateDevelopmentalRubricFormField,
} from "../../store/actions/developmental-rubrics.actions.js";
import { handlerErrorV2 } from "../../utils/errors.jsx";
import { toggleAlertModule } from "../../store/actions/alert.actions";


const useWorkedExamples = () => {
  const { curriculumId, id } = useParams();

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const workedExamples = useSelector((state) => state?.dr?.form?.workedExamples || [])

  const onUpdateFormData = (data, type) => {
    if (type === 'create') {
      const newQuestion = {
        _id: data._id || new Date().getTime(),
        id: data._id || new Date().getTime(),
        comment: data.comment,
        media: data.media || []
      }
      dispatch(updateDevelopmentalRubricFormField('workedExamples', [...workedExamples, newQuestion]))
    } else if (type === 'edit') {
      const newFormData = workedExamples
        .map((item) => ({ ...item, _id: item._id || item.id }))
        .map((item) => {
        if (String(item._id) === String(data._id)) {
          return {
            ...item,
            comment: data.comment,
            media: data.media || []
          }
        }
        return item
      })
      dispatch(updateDevelopmentalRubricFormField('workedExamples', newFormData))
    } else if (type === 'delete') {
      const newFormData = workedExamples.map((item) => ({ ...item, _id: item._id || item.id }))
        .filter((item) => String(item._id) !== String(data._id))
      dispatch(updateDevelopmentalRubricFormField('workedExamples', newFormData))
    }
  }

  const formData = (form) => {
    return {
      comment: form.comment,
      media: form.media
    }
  };
  const createWorkedExample = async (form = {}) => {
    try {
      const data = formData(form);
      const response = await createWorkedExampleService(
        curriculumId,
        id,
        data
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        onUpdateFormData(response.data, 'create')
        enqueueSnackbar("Developmental rubric updated successfully", {
          variant: "success",
        });
        dispatch(toggleAlertModule());

        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    }
  };

  const updateWorkedExample = async (weId, form = {}) => {
    try {
      const data = formData(form);
      const response = await updateWorkedExampleService(
        curriculumId,
        id,
        weId,
        data
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        onUpdateFormData(response.data, 'edit')
        enqueueSnackbar("Developmental rubric updated successfully", {
          variant: "success",
        });
        dispatch(toggleAlertModule());

        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    }
  };

  const deleteWorkedExample = async (weId) => {
    setIsLoading(true);
    try {
      const response = await deleteWorkedExampleService(
        curriculumId,
        id,
        weId
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        onUpdateFormData({ _id: weId }, 'delete')
        enqueueSnackbar("Developmental rubric updated successfully", {
          variant: "success",
        });

        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    createWorkedExample,
    updateWorkedExample,
    deleteWorkedExample,
  };
};

export default useWorkedExamples;
